import type { ChartV2Horizon, ChartV2Interval } from './types/chart-v2.types';

export const DEFAULT_PANE_ID_PREFIX = 'pane-';
export const DEFAULT_PANE_ID = `${DEFAULT_PANE_ID_PREFIX}0`;

export const DEFAULT_HORIZONS: ChartV2Horizon[] = [
  '1D',
  '1W',
  '2W',
  '1M',
  '2M',
  '3M',
  '6M',
  '1Y',
  '3Y',
  '5Y',
  '10Y',
  'MAX',
];

export const DEFAULT_INTERVALS: ChartV2Interval[] = [
  '1m',
  '5m',
  '15m',
  '30m',
  '1h',
  '1D',
  '1W',
  '1M',
];
